import { z } from "zod";

export const defaultRouteSchema = z.object({
  id: z.number(),
  name: z.string(),
  truck: z.object({
    id: z.number(),
    title: z.string(),
    licence: z.string().optional(),
  }),
  active: z.boolean(),
});
